import * as fromDashboardActions from 'src/app/state-management/actions/dashboard.action';
import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { Store } from '@ngrx/store';
import { Observable, Subject, Subscription, takeUntil } from 'rxjs';
import { ScreenType } from 'src/app/enums/ScreenType';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import {
  IDashboardState,
  INotifications,
} from 'src/app/state-management/states/aumye-dashboard.state';
import { IAumyeState } from 'src/app/state-management/states/aumye.state';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import * as fromUserProfileActions from 'src/app/state-management/actions/user-profile.actions';
import { Actions, ofType } from '@ngrx/effects';
import { ProfilePicUserService } from 'src/app/services/ProfilePic/profile-pic-user.service';
import { Router } from '@angular/router';
import { AumyeGatewayService } from 'src/app/services/aumye-gateway.service';
import { IncidentDetails } from 'src/app/services/realTimeData/aumye-firebase-realtime-db.service';
import { EncryptionService } from 'src/app/services/Encryption/encryption.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  @ViewChild('sidenav') sidenav: MatSidenav;
  @ViewChild('LogOutDialog', { static: true }) logOutDialog: TemplateRef<any>;
  @Output() onClickSideMenu = new EventEmitter();
  @Output() onVisitorManage = new EventEmitter();
  @Output() onUserLogOut = new EventEmitter();
  @Output() onUserAccountSettings = new EventEmitter();
  userRole: string = null;
  destroyed$: Subject<any> = new Subject<any>();
  data$: Observable<IDashboardState>;
  data: IDashboardState;
  orgName: string = null;
  tempProfile =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAMAAAD04JH5AAAAMFBMVEXk5ueutLepr7Ln6erg4uPJzc/T1ti7wMO2u77DyMqzuLvq7O3P0tTW2dvc3+DZ3N7ueM45AAAC2UlEQVR4nO2a2ZLjIAxFAYHZvPz/3za2O8v0JCA5kl3dxXly5eXeCAmDZKU6nU6n0+l0Op1O5/cCAErZglofzle3UwxJryTvFnWuB4DJa2P0DWNSnM+zAHnUD/G7Cb/kc/Tz9EJ+t3DKQkB8Lb8xiDsAFSr62jhhB2BTRX51EEUdgK3Lb4kg6qDx/6VjAL6tXxyMUg7A1fLvyYHQngQLTr/szUIGAlJfqBhhxAagIKCvAC+vtUQIBkIAtOE3kNEZsBkQKEVKALQO3AZIKbiGwHIbQG2CTwbYX8w0fa253wgzbQVKEvDqA6kIN5gNIN9DT8y8BiJVXy8XGzATrwFiFa51+McMXL4Elyfh1WVIOw1s8OorS96K/9rL6PLXMfVAorkPJApoBvivqLQ1MBP/oRR9MdsQuBcA4mp+D4DI3WwihEDkdorPAv4j8U67P/ONVJcGvRdYqRZJ9hgHEiV4A9OjkGsRbVTblJu+dKuy4UBcvxRjtVUr3ywup7P38uGUoQHM74Lgzprd5OVFJpgoVv6vLMzu35FNGE+eGq1TqzH6kFIKPg7XDM4y3Mhnz8zK/7XLMLq44cZhmfdfTxDPah5jKKu+ck+B9TlFNynRYKzDSheek+9nIWiT4mBlIlGCPnj9ZmD3bMLo4Gb2kthHpS3xhwk/sFoA5RLxXmLKvsQ1SAVbG1VWPISFIwpF/oj6bsEzWHg1pyZYiJ/lQl6oa/+fAz1+kAr52OL/sJCOBgHm5gEQybFjEgw86nrLBDqZ3herOPDkRKh+pnDAAXV8wKyvqQMMfn2aA9b1fzhA5wFQWhF48N9WkLuiWAfY/YA0pCWBamAfaIyjQTWQ0Y2YA2B6B5k8nCHRDgB5REqi3T6gT6eINNdANADtUpQsgR3fCIDcHnCjPkiQ2gQf1NfgwJSeTPVscmA+SSbVVgD/tdYHVJOAMJQ4TG2ma78bD6LwjtU7nU6n8/v5AuY6HZyRatEhAAAAAElFTkSuQmCC';
  profilePic: string;
  fullName: string = null;
  screenSize: ScreenType;
  orgId: string = null;
  userId: string = null;
  ActiveUsers: string =
    'Organizations/' + this.orgId + '/ActiveUsers/' + this.userId;
  Gateway: string = 'Organizations/' + this.orgId + '/Gateway';
  gatewaystatus = 'unavailable';
  private intervalId: any;
  private dbSubscription: Subscription;
  profilePic$: Observable<string>;
  private profilePicSubscription: Subscription;
  icons: string[] = [
    'signal_cellular_off',
    'signal_cellular_alt_1_bar',
    'signal_cellular_alt_2_bar',
    'signal_cellular_alt',
  ];
  signalStatus: string = this.icons[0];
  notifications: INotifications[] = [];
  unreadNotifications: number = 0;
  readNotifications: number = 0;
  maxNotificationsToShow = 5;
  hasUnread = false;
  showingAllNotifications = false;
  showUnreadOnly = false;
  showReadOnly = false;
  showTotalOnly = false;
  filteredNotifications: INotifications[] = [];
  decryptedUserData: any;

  constructor(
    private store: Store<IAumyeState>,
    private dialog: MatDialog,
    private _screenSize: AumyeResponsiveScreenService,
    private db: AngularFireDatabase,
    private actions$: Actions,
    private profilePicService: ProfilePicUserService,
    private router: Router,
    private gatewayService: AumyeGatewayService,
    private encryptionService: EncryptionService
  ) {
    this.data$ = this.store.select('aumyeDashboardState');
    this.data$.pipe(takeUntil(this.destroyed$)).subscribe((data) => {
      this.data = data;
      this.loadNotificationsFromStorage();
    });
    this._screenSize.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
    this.fullName =
      this.screenSize == ScreenType.Mobile && this.fullName?.length > 11
        ? this.fullName.split(' ')[0]
        : this.fullName;
    this.actions$
      .pipe(
        ofType(
          fromUserProfileActions.UserProfileActionTypes.GET_USER_DETAILS_SUCCESS
        )
      )
      .subscribe(() => {
        this.profilePic =
          localStorage.getItem('ProfilePic') == null ||
          localStorage.getItem('ProfilePic')?.length == 0
            ? this.tempProfile
            : localStorage.getItem('ProfilePic');

        if (localStorage.getItem('FullName')) {
          this.fullName = localStorage.getItem('FullName');
        }
      });
  }
  ngOnInit(): void {
    this.decryptedUserData = this.encryptionService.getCurrentUser();
    this.orgName = this.decryptedUserData.organizationName;
    this.orgId = this.decryptedUserData.organizationID;
    this.userId = this.decryptedUserData.userID;
    this.userRole = this.decryptedUserData.role;
    this.fullName =
      this.decryptedUserData.firstName + ' ' + this.decryptedUserData.lastName;
    this.profilePicService.profilePic$.subscribe((profilePic) => {
      this.profilePic = profilePic;
    });
    // if (this.orgId != '766773b7-51e9-4951-a2de-6245e6233758') {
    //   this.gatewayService.getGatewayStatus().subscribe((data) => {
    //     this.gatewaystatus =
    //       data[0].NetworkStatus == 'Down' ? 'unavailable' : 'available';
    //     this.signalStatus = this.icons[parseInt(data[0].NetworkStrength) || 0];
    //   });
    // }
  }
  onClickAumYeLogo() {
    this.store.dispatch(new fromDashboardActions.InitDashboard({}));
  }
  onClickMenu() {
    if (this.userRole != 'kiosk') this.onClickSideMenu.emit();
  }
  onClickLogOut() {
    this.onUserLogOut.emit();
    this.deleteDataOnFirebase();
    this.openDialog();
  }
  onClickAccountSettings() {
    this.onUserAccountSettings.emit();
  }
  onClickVisitorManage() {
    this.onVisitorManage.emit();
  }
  openDialog() {
    let dialogRef = this.dialog.open(this.logOutDialog);
    setTimeout(() => {
      dialogRef.close();
    }, 2000);
  }
  ScreenType = ScreenType;
  deleteDataOnFirebase() {
    this.db.object(this.ActiveUsers).remove();
  }
  // checkGatewayStatus() {
  //   this.db
  //     .object(this.Gateway)
  //     .valueChanges()
  //     .subscribe((data) => {
  //       if (data) {
  //         this.gatewaystatus = 'available';
  //       } else {
  //         this.gatewaystatus = 'unavailable';
  //       }
  //     });
  // }
  removeGateway() {
    this.db.object(this.Gateway).remove();
  }
  ngOnDestroy() {
    if (this.profilePicSubscription) this.profilePicSubscription.unsubscribe();
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    if (this.dbSubscription) {
      this.dbSubscription.unsubscribe();
    }
  }
  // Function to mark a notification as read
  markNotificationAsRead(notificationId: string, event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    // Get current notifications
    const currentNotifications = this.getNotificationsFromStorage();

    // Update the notification's read status instead of removing it
    const updatedNotifications = currentNotifications.map((notification) =>
      notification.notificationId === notificationId
        ? { ...notification, read: true }
        : notification
    );
    // Save updated notifications
    localStorage.setItem(
      'userNotifications',
      JSON.stringify(updatedNotifications)
    );

    // Update component state
    this.notifications = updatedNotifications;
    this.unreadNotifications = this.notifications.filter((n) => !n.read).length;
    this.readNotifications = this.notifications.filter((n) => n.read).length;
    if (this.showUnreadOnly) {
      this.filteredNotifications = this.notifications.filter((n) => !n.read);
    } else {
      this.filteredNotifications = [...this.notifications];
    }
  }
  // Function to clear all notifications
  clearAllNotifications(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }

    // Clear notifications in localStorage
    localStorage.setItem('userNotifications', JSON.stringify([]));

    // Update component state
    this.notifications = [];
    this.updateUnreadCount();
  }
  // Function to get notifications from localStorage
  getNotificationsFromStorage(): INotifications[] {
    const storedNotifications = localStorage.getItem('userNotifications');
    return storedNotifications ? JSON.parse(storedNotifications) : [];
  }
  // Function to load notifications from localStorage (call this in ngOnInit)
  loadNotificationsFromStorage(): void {
    this.notifications = this.getNotificationsFromStorage();
    this.filteredNotifications = [...this.notifications];

    // Filter out invalid or unmatched organization notifications
    this.filteredNotifications = this.notifications.filter(
      (notification) =>
        notification.notificationOrg &&
        notification.notificationOrg.trim() !== '' &&
        notification.notificationOrg === this.orgId
    );

    this.unreadNotifications = this.notifications.filter(
      (notification) => !notification.read
    ).length;
    this.readNotifications = this.notifications.filter((n) => n.read).length;
  }
  // Function to update unread count
  updateUnreadCount(): void {
    this.unreadNotifications = this.notifications.filter(
      (notification) => !notification.read
    ).length;
    this.readNotifications = this.notifications.filter((n) => n.read).length;
  }
  // Function to delete notification (same as marking as read in your implementation)
  deleteNotification(notificationId: string, event: Event): void {
    event.stopPropagation();
    this.markNotificationAsRead(notificationId);
  }
  // Function to mark all notifications as read
  markAllAsRead(event: Event): void {
    event.stopPropagation();
    this.clearAllNotifications();
  }
  resetFilter() {
    this.filteredNotifications = [...this.notifications];
    this.showUnreadOnly = false;
    this.showReadOnly = false;
    this.showTotalOnly = false;
  }
  toggleUnread(event: Event) {
    event.stopPropagation(); // Prevents menu from closing
    if (this.showUnreadOnly) {
      this.resetFilter();
    } else {
      this.filteredNotifications = this.notifications.filter((n) => !n.read);
      this.showUnreadOnly = true;
      this.showReadOnly = false;
      this.showTotalOnly = false;
    }
  }

  toggleRead(event: Event) {
    event.stopPropagation(); // Prevents menu from closing
    if (this.showReadOnly) {
      this.resetFilter();
    } else {
      this.filteredNotifications = this.notifications.filter((n) => n.read);
      this.showUnreadOnly = false;
      this.showReadOnly = true;
      this.showTotalOnly = false;
    }
  }

  toggleTotal(event: Event) {
    event.stopPropagation(); // Prevents menu from closing
    if (this.showTotalOnly) {
      this.resetFilter();
    } else {
      this.filteredNotifications = [...this.notifications];
      this.showUnreadOnly = false;
      this.showReadOnly = false;
      this.showTotalOnly = true;
    }
  }

  getFlowType(id: string): string {
    const incidentLists: (keyof IncidentDetails)[] = [
      'incidentList',
      'criticalIncidentList',
      'mediumIncidentList',
      'lowIncidentList',
      'noIncidentList',
      'recentActivityIncidentList',
    ];
    const incidentDetails = this.data.incidentDetails;
    for (const listName of incidentLists) {
      if (
        incidentDetails[listName].some((incident) => incident.incidentId === id)
      ) {
        return 'Incident';
      }
    }

    // Check Visitor Details
    if (
      this.data.visitorDetails.visitorList?.some(
        (visitor) => visitor.visitorID === id
      )
    ) {
      return 'Visitor';
    }

    // Check Notice Board
    if (this.data.noticeBoardPosts?.some((notice) => notice.postId === id)) {
      return 'NoticeBoard';
    }

    // Check Complaints Details
    if (
      this.data.complaintsTickets?.some(
        (complain) => complain.complainId === id
      )
    ) {
      return 'Complaints';
    }

    // Check Claims Details
    if (this.data.claimTickets?.some((claim) => claim.complainId === id)) {
      return 'Claims';
    }

    // Check Service Requests Details
    if (
      this.data.requestsTickets?.some((request) => request.complainId === id)
    ) {
      return 'Requests';
    }
    return 'not_found';
  }
  // Function to open a notification
  openNotification(notification: INotifications): void {
    const flow = this.getFlowType(notification?.notificationId?.toLowerCase());
    if (
      notification.notificationFlowType == 'Incident Update' ||
      notification.notificationFlowType == 'New Incident' ||
      notification.notificationFlowType == 'New Other' ||
      notification.notificationFlowType == 'New Claim' ||
      notification.notificationFlowType == 'New HouseKeeping' ||
      notification.notificationFlowType == 'New Leave' ||
      notification.notificationFlowType == 'New Electrical' ||
      notification.notificationFlowType == 'New Service Request' ||
      notification.notificationFlowType == 'New Complain'
    ) {
      this.router.navigateByUrl(
        `/dashboard/view?linkType=incident&id=${notification.notificationId}`
      );
    } else if (
      notification.notificationFlowType == 'New Visitor' ||
      notification.notificationFlowType === 'Update Visitor'
    ) {
      this.router.navigateByUrl(
        `/dashboard/view?linkType=visitor&id=${notification.notificationId}`
      );
    } else if (
      notification.notificationFlowType == 'Comment' ||
      notification.notificationFlowType == 'Comments'
    ) {
      if (flow === 'Visitor') {
        this.router.navigateByUrl(
          `/dashboard/view?linkType=visitor&id=${notification.notificationId}`
        );
      } else {
        this.router.navigateByUrl(
          `/dashboard/view?linkType=incident&id=${notification.notificationId}`
        );
      }
    }
    if (!notification.read) {
      notification.read = true;
      this.updateUnreadCount();
      // API call to update read status if needed
    }
    this.markNotificationAsRead(notification.notificationId);
  }
  // Function to view all notifications
  viewAllNotifications(): void {
    this.showingAllNotifications = true;
  }
  // Function to get notification icon based on type
  getNotificationIcon(notification: INotifications): string {
    switch (notification.type) {
      case 'INFO':
        return 'info';
      case 'SUCCESS':
        return 'check_circle';
      case 'WARNING':
        return 'warning';
      case 'ERROR':
        return 'error';
      default:
        return 'notifications';
    }
  }
  // Function to get notification icon class
  getNotificationIconClass(notification: INotifications): string {
    return notification.type ? notification.type.toLowerCase() : '';
  }
  getTimeAgo(date: Date): string {
    if (!date) return '';
    const now = new Date();
    const seconds = Math.floor(
      (now.getTime() - new Date(date).getTime()) / 1000
    );

    if (seconds < 60) return 'just now';

    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes}m ago`;

    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}h ago`;

    const days = Math.floor(hours / 24);
    if (days < 30) return `${days}d ago`;

    const months = Math.floor(days / 30);
    return `${months}mo ago`;
  }
}
function lowerCaseFirstLetterOfKeys(obj: any): any {
  return Object.keys(obj).reduce((acc: any, key: string) => {
    const newKey = key.charAt(0).toLowerCase() + key.slice(1);
    acc[newKey] = obj[key];
    return acc;
  }, {});
}
